<template>
  <div class="audit-page">
    <!-- 标签页组件 -->
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
      <el-tab-pane label="审核" name="audit">
        <!-- 审核查询表单 -->
        <div class="search-form">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline responsive-form">
            <el-form-item label="学校" prop="school">
              <el-select v-model="searchForm.school" placeholder="请选择学校" class="school-select" filterable clearable>
                <el-option v-for="school in schoolList" :key="school.id" :label="school.schName"
                  :value="school.schName"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="提交日期">
              <el-date-picker v-model="searchForm.submitDate" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                class="date-picker-mobile" style="width: 100%;"></el-date-picker>
            </el-form-item>

            <el-form-item label="审核情况">
              <el-select v-model="searchForm.auditStatus" placeholder="请选择审核情况">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="1"></el-option>
                <el-option label="审核通过" value="0"></el-option>
                <el-option label="审核拒绝" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="身份证号">
              <el-input v-model="searchForm.idCard" placeholder="请输入学生身份证号"></el-input>
            </el-form-item>

            <el-form-item class="action-buttons">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
              <!-- 新增：导出选中按钮 -->
              <el-button type="success" icon="Download" @click="ExportApplications"
                :disabled="selectedRowKeys.length === 0" style="margin-left: 8px;">
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 申请单列表 -->
        <div class="application-list">
          <el-table :data="applicationList" border style="width: 100%;" :header-cell-style="{ background: '#f5f5f5' }"
            :loading="listLoading" :row-key="getRowKey" @selection-change="handleSelectionChange">
            <!-- 新增：选择框列 -->
            <el-table-column type="selection" width="55" align="center"></el-table-column>

            <el-table-column prop="name" label="姓名" text-align="center">
            </el-table-column>

            <el-table-column prop="school" label="学校" text-align="center">
            </el-table-column>

            <el-table-column prop="submitDate" label="提交日期" text-align="center">
            </el-table-column>

            <el-table-column prop="auditStatus" label="审核状态" text-align="center">
              <template #default="scope">
                <el-tag :type="statusType[scope.row.auditStatus]">
                  {{ statusText[scope.row.auditStatus] }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" text-align="center">
              <template #default="scope">
                <el-button type="text" icon="el-icon-view" @click="viewDetail(scope.row)">查看</el-button>
                <!-- <el-button
                  type="text"
                  icon="el-icon-check"
                  @click="approveApplication(scope.row)"
                  :disabled="scope.row.auditStatus !== '1'">通过</el-button>
                <el-button
                  type="text"
                  icon="el-icon-close"
                  @click="rejectApplication(scope.row)"
                  :disabled="scope.row.auditStatus !== '1'">拒绝</el-button> -->
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <div class="pagination">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="total" :page-size="pageSize"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="个人中心" name="profile">
        <div class="profile-content">
          <div class="profile-card">
            <h3>个人功能</h3>

            <!-- 医生签字功能 -->
            <div class="profile-item">
              <span class="item-label">医生签字：</span>
              <div class="item-content">
                <el-button type="primary" icon="EditPen" @click="openSignaturePad" :disabled="hasSigned">
                  医生签字
                </el-button>
                <span v-if="hasSigned" class="signed-mark">
                  <i class="el-icon-check"></i> 已完成签字
                </span>
              </div>
            </div>

            <!-- 导出Excel功能 -->
            <div class="profile-item">
              <span class="item-label">数据导出：</span>
              <div class="item-content">
                <el-button type="success" icon="Download" @click="exportAllApplications">
                  导出全部申请数据
                </el-button>
              </div>
            </div>
            <div class="submit-btn-container">
              <!-- 新增退出登录按钮 -->
              <van-button type="default" class="logout-btn" @click="handleLogout"
                :disabled="isUploading || isSubmitting" style="margin-top: 12px;">
                退出登录
              </van-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 医生签字弹窗 -->
    <el-dialog title="医生电子签字 (请横屏操作)" :visible.sync="signatureDialogVisible" width="90%" height="80vh"
      :fullscreen="false" :show-close="false" custom-class="signature-dialog">
      <div class="signature-pad-container">
        <div ref="signaturePad" class="signature-pad" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
          @mouseleave="stopDrawing" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
          @touchend="handleTouchEnd">
        </div>
      </div>
      <div class="signature-actions">
        <el-button @click="clearSignature">清空</el-button>
        <el-button type="primary" @click="saveSignature" :loading="isUploadingSignature">保存签字</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 引入所需库
import html2canvas from 'html2canvas';
import request from '@/utils/request';
import { ElMessage } from 'element-plus';

export default {
  name: 'Yishengshenhe',
  data() {
    return {
      // 当前激活的标签页名称
      activeTabName: 'audit',

      // 查询表单数据（auditStatus对应后端状态码：0通过/1待审核/2驳回）
      searchForm: {
        school: '',
        submitDate: [],
        auditStatus: '',
        idCard: ''
      },

      // 申请单列表数据（初始化空数组）
      applicationList: [],
      schoolList: [], // 学校列表

      // 分页相关
      total: 0,
      pageSize: 10,
      currentPage: 1,
      listLoading: false, // 列表加载状态

      // 状态文本映射（后端状态码：0=已通过/1=未审核/2=已驳回）
      statusText: {
        '0': '审核通过',
        '1': '待审核',
        '2': '审核拒绝'
      },

      // 状态标签类型映射
      statusType: {
        '0': 'success', // 已通过-绿色
        '1': 'info',    // 待审核-蓝色
        '2': 'danger'   // 已驳回-红色
      },

      // 个人中心 - 签字相关
      signatureDialogVisible: false,
      hasSigned: false,
      signatureImage: '',
      isUploadingSignature: false, // 签字上传状态
      physicianPhone: '', // 存储医生登录手机号

      // 画布绘图相关
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      context: null,

      // 新增：选择相关状态
      selectedRowKeys: [], // 选中的行ID集合
      selectedRows: [] // 选中的行数据集合
    };
  },
  mounted() {
    // 初始化时读取医生登录手机号（假设登录时已存入localStorage，键为physicianPhone）
    this.physicianPhone = localStorage.getItem('physicianPhone') || '';
    // 检查本地存储中是否已有签字
    if (localStorage.getItem('doctorSignature')) {
      this.hasSigned = true;
      this.signatureImage = localStorage.getItem('doctorSignature');
    }
    // 页面挂载后默认查询一次数据
    this.fetchApplicationList();
  },
  created() {
    // 页面加载时查询所有学校
    this.fetchSchoolList();
  },
  methods: {
    // 标签页切换时触发
    handleTabClick(tab, event) {
      console.log(tab, event);
    },

    // 查询所有学校
    fetchSchoolList() {
      request({
        url: '/api/schoolInfos/all',
        method: 'get',
      }).then(response => {
        if (response.code === 200 && Array.isArray(response.data)) {
          this.schoolList = response.data;
          console.log('获取学校列表成功:', this.schoolList);
        } else {
          this.$message.error('获取学校列表失败');
        }
      }).catch(error => {
        this.$message.error('获取学校列表失败');
        console.error('获取学校列表失败:', error);
      });
    },

    // 核心：调用接口查询申请单列表（优化版）
    fetchApplicationList() {
      this.listLoading = true; // 开始加载

      request({
        url: '/api/review/listAll',
        method: 'get',
        headers: {
          "accept": "application/json, text/plain, */*",
          "content-type": "application/json"
        },
        withCredentials: false,
        timeout: 10000
      }).then(response => {
        this.listLoading = false; // 结束加载

        // 兼容接口响应格式
        let resData = typeof response === 'string' ? JSON.parse(response) : response;

        if (resData.code !== 200 || !Array.isArray(resData.data)) {
          this.$message.error(`获取申请单列表失败: ${resData.message || '服务器未返回有效数据'}`);
          this.applicationList = [];
          this.total = 0;
          this.selectedRowKeys = []; // 清空选择
          this.selectedRows = [];
          return;
        }

        // 1. 先过滤查询条件（前端筛选）
        let filteredList = resData.data.filter(item => {
          // 学校筛选
          if (this.searchForm.school && item.reChildrenSchool !== this.searchForm.school) return false;
          // 审核状态筛选
          if (this.searchForm.auditStatus !== '' && item.reStatus.toString() !== this.searchForm.auditStatus) return false;
          // 身份证号筛选
          if (this.searchForm.idCard && item.reChildrenSfz !== this.searchForm.idCard) return false;
          // 日期范围筛选
          if (this.searchForm.submitDate && this.searchForm.submitDate[0]) {
            const itemDate = this.formatDate(item.createTime);
            const startDate = this.searchForm.submitDate[0];
            const endDate = this.searchForm.submitDate[1] || startDate;
            if (itemDate < startDate || itemDate > endDate) return false;
          }
          return true;
        });

        // 2. 格式化数据（确保id字段必有值）
        this.applicationList = this.formatApplicationList(filteredList);

        // 3. 分页处理（前端分页）
        this.total = this.applicationList.length;
        const startIndex = (this.currentPage - 1) * this.pageSize;
        this.applicationList = this.applicationList.slice(startIndex, startIndex + this.pageSize);

        console.log('获取申请单列表成功，共', this.total, '条记录。');
        console.log('格式化后列表数据（含id）:', this.applicationList.map(item => ({ id: item.id, name: item.name })));

      }).catch(error => {
        this.listLoading = false;
        const errorMsg = error.message.includes('CORS')
          ? '获取数据失败：跨域配置异常，请联系管理员'
          : '获取数据失败：网络异常或服务器错误';
        this.$message.error(errorMsg);
        console.error('调用 /api/review/listAll 失败:', error);
        this.applicationList = [];
        this.total = 0;
        this.selectedRowKeys = []; // 清空选择
        this.selectedRows = [];
      });
    },

    // 格式化列表数据（确保id字段必有值，兼容多种主键）
    formatApplicationList(rawList) {
      if (!Array.isArray(rawList)) return [];

      return rawList.map(item => ({
        // 优先取id，无则取reId，再无则取queId，最后生成临时ID避免空值
        id: item.id || item.reId || item.queId || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        name: item.reChildrenName || item.queChildrenName || item.childrenName || '未知姓名',
        school: item.reChildrenSchool || item.queChildrenSchool || item.school || '未知学校',
        submitDate: item.createTime || item.queCreateTime || item.submitDate
          ? this.formatDate(item.createTime || item.queCreateTime || item.submitDate)
          : '未知时间',
        auditStatus: (item.reStatus ?? item.queStatus ?? item.auditStatus ?? '').toString(),
        idCard: item.reChildrenSfz || item.queChildrenSfz || item.childrenSfz || '未填写',
        // 保留原始字段，便于导出和后续操作
        rawId: item.id,
        rawReId: item.reId,
        rawQueId: item.queId,
        reChildrenName: item.reChildrenName,
        reChildrenSchool: item.reChildrenSchool,
        reStatus: item.reStatus,
        createTime: item.createTime
      }));
    },

    // 日期格式化（兼容更多日期格式）
    formatDate(dateStr) {
      if (!dateStr) return '';
      // 处理时间戳格式（如果接口返回数字类型）
      if (typeof dateStr === 'number') {
        dateStr = dateStr.toString().length === 13 ? dateStr : dateStr * 1000;
      }
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return '格式错误';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },

    // 点击查询按钮
    handleSearch() {
      this.currentPage = 1;
      this.selectedRowKeys = []; // 重置选择
      this.selectedRows = [];
      this.fetchApplicationList();
    },

    // 重置查询表单
    resetForm() {
      this.searchForm = {
        school: '',
        submitDate: [],
        auditStatus: '',
        idCard: ''
      };
      this.currentPage = 1;
      this.selectedRowKeys = []; // 重置选择
      this.selectedRows = [];
      this.fetchApplicationList();
    },

    // 查看申请单详情（完整修复版：参数校验+异常捕获+路由兼容）
    viewDetail(row) {
      console.log('查看详情-当前行数据:', row);

      // 1. 校验行数据和id字段
      if (!row) {
        this.$message.error('行数据为空无法查看详情');
        return;
      }

      const detailId = row.id;
      if (!detailId) {
        this.$message.warning('该记录无有效ID，无法查看详情');
        console.warn('无效的审核单ID:', detailId);
        return;
      }

      // 2. 尝试跳转详情页，捕获所有异常
      try {
        // 兼容路由配置（两种方式都尝试，确保跳转成功）
        const jumpSuccess = this.$router.push({
          path: '/applicationdetail',
          query: { id: detailId } // 传递审核单ID（reId）
        });

        // 如果是Vue Router 3.x，push返回Promise，可捕获错误
        if (jumpSuccess && jumpSuccess.catch) {
          jumpSuccess.catch(error => {
            console.error('跳转详情页失败（Promise捕获）:', error);
            this.handleRouteError(error);
          });
        }
      } catch (error) {
        console.error('跳转详情页失败（try-catch捕获）:', error);
        this.handleRouteError(error);
      }
    },

    // 统一处理路由跳转错误
    handleRouteError(error) {
      if (error.message.includes('Cannot find module')) {
        this.$message.error('跳转失败：详情页组件未找到，请检查组件路径是否正确');
      } else if (error.message.includes('Route with name') || error.message.includes('path')) {
        this.$message.error('跳转失败：详情页路由未注册，请检查router/index.js配置');
      } else if (error.message.includes('NavigationDuplicated')) {
        this.$message.warning('已在详情页，无需重复跳转');
      } else {
        this.$message.error(`跳转失败：${error.message || '未知错误'}`);
      }
    },

    // // 通过申请
    // approveApplication(row) {
    //   this.updateAuditStatus(row.id, 0, '审核通过');
    // },

    // // 拒绝申请
    // rejectApplication(row) {
    //   this.updateAuditStatus(row.id, 2, '审核拒绝');
    // },

    // 统一调用审核状态更新接口
    updateAuditStatus(reId, status, statusText) {
      request({
        url: '/api/review/updateStatus',
        method: 'put',
        data: { reId, reStatus: status }
      }).then(response => {
        if (response.code === 200) {
          this.$message.success(`已${statusText}该申请`);
          this.fetchApplicationList(); // 刷新列表
          this.selectedRowKeys = []; // 刷新后清空选择
          this.selectedRows = [];
        } else {
          this.$message.error(`${statusText}失败：${response.message || '服务器错误'}`);
        }
      }).catch(error => {
        this.$message.error(`${statusText}失败：网络异常`);
        console.error(`${statusText}接口调用失败:", error`);
      });
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 页码重置为1
      this.selectedRowKeys = []; // 切换条数后清空选择
      this.selectedRows = [];
      this.fetchApplicationList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectedRowKeys = []; // 切换页码后清空选择
      this.selectedRows = [];
      this.fetchApplicationList();
    },

    // 打开签字弹窗
    openSignaturePad() {
      if (!this.physicianPhone) {
        this.$message.error('未获取到医生登录信息，请重新登录');
        return;
      }
      this.signatureDialogVisible = true;
      this.$nextTick(() => this.initSignaturePad());
    },

    // 初始化签字画布
    initSignaturePad() {
      const canvas = document.createElement('canvas');
      const pad = this.$refs.signaturePad;
      canvas.width = pad.clientWidth > 0 ? pad.clientWidth : 300;
      canvas.height = pad.clientHeight > 0 ? pad.clientHeight : 200;

      pad.innerHTML = '';
      pad.appendChild(canvas);

      this.context = canvas.getContext('2d');
      this.context.lineWidth = 5;
      this.context.lineCap = 'round';
      this.context.strokeStyle = '#000000';
    },

    // 开始绘制 (PC)
    startDrawing(e) {
      this.isDrawing = true;
      [this.lastX, this.lastY] = [e.offsetX, e.offsetY];
    },

    // 绘制中 (PC)
    draw(e) {
      if (!this.isDrawing) return;
      this.context.beginPath();
      this.context.moveTo(this.lastX, this.lastY);
      this.context.lineTo(e.offsetX, e.offsetY);
      this.context.stroke();
      [this.lastX, this.lastY] = [e.offsetX, e.offsetY];
    },

    // 结束绘制 (PC)
    stopDrawing() {
      this.isDrawing = false;
    },

    // 处理触摸事件 (移动设备)
    handleTouchStart(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const rect = this.$refs.signaturePad.getBoundingClientRect();
      this.startDrawing({
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top
      });
    },

    handleTouchMove(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const rect = this.$refs.signaturePad.getBoundingClientRect();
      this.draw({
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top
      });
    },

    handleTouchEnd(e) {
      e.preventDefault();
      this.stopDrawing();
    },

    // 清空画布
    clearSignature() {
      this.initSignaturePad();
    },

    /**
     * 将 data URL 转换为 Blob 对象
     */
    dataURLToBlob(dataURL) {
      if (!dataURL || typeof dataURL !== 'string' || !dataURL.startsWith('data:')) {
        console.error('无效的 dataURL:', dataURL);
        return null;
      }

      const arr = dataURL.split(',');
      if (arr.length < 2) {
        console.error('dataURL 格式错误:', dataURL);
        return null;
      }

      const matchResult = arr[0].match(/:(.*?);/);
      const mime = matchResult ? matchResult[1] : 'image/png';
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    // 保存签字（调用接口上传）
    async saveSignature() {
      const canvas = this.$refs.signaturePad.querySelector('canvas');
      if (!canvas) {
        this.$message.error('签字画布未初始化！');
        return;
      }

      const isCanvasEmpty = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data.every(byte => byte === 0);
      if (isCanvasEmpty) {
        this.$message.warning('请先在画布上签字再保存。');
        return;
      }

      if (!this.physicianPhone) {
        this.$message.error('未获取到医生登录信息，无法上传签字');
        return;
      }

      this.isUploadingSignature = true;
      try {
        const dataURL = canvas.toDataURL('image/png');
        if (!dataURL) {
          throw new Error('获取 canvas dataURL 失败');
        }

        const blob = this.dataURLToBlob(dataURL);
        if (!blob) {
          throw new Error('将 dataURL 转换为 Blob 对象失败');
        }

        const formData = new FormData();
        formData.append('psId', this.physicianPhone);
        formData.append('file', blob, 'doctor_signature.png');

        const response = await request({
          url: '/api/physicians/uploadSignature',
          method: 'post',
          data: formData,
        });

        if (response.code === 200) {
          this.signatureImage = dataURL;
          localStorage.setItem('doctorSignature', this.signatureImage);
          this.hasSigned = true;
          this.signatureDialogVisible = false;
          this.$message.success('签名上传成功！');
        } else {
          this.$message.error(`签名上传失败：${response.message || '服务器错误'}`);
        }
      } catch (error) {
        this.$message.error('签名上传失败：处理图像数据时发生错误');
        console.error('签字上传失败:', error);
      } finally {
        this.isUploadingSignature = false;
      }
    },

    /**
      * 公共文件下载函数（处理 blob 流）
      * @param {Blob} blob - 文件流 blob 对象
      * @param {string} fileName - 下载文件名
      */
    downloadFileFromBlob(blob, fileName) {
      if (!blob || !(blob instanceof Blob)) {
        ElMessage.error('文件数据无效，无法下载');
        return;
      }

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.style.display = 'none';

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理临时资源（避免内存泄漏）
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    },

    /**
     * 核心导出函数（复用逻辑）
     * @param {string[]} idCardList - 身份证号数组（空数组导出全部）
     * @param {string} fileName - 下载文件名
     */
    async handleExport(idCardList, fileName) {
      try {
        ElMessage.info(`正在导出数据，请稍候...`);
        console.log('--- 开始导出 ---', { idCardList, fileName });

        // 调用修复后的 request 工具（会返回完整响应对象）
        const response = await request({
          url: '/api/review/exportToExcel',
          method: 'post',
          data: { idCardList },
          responseType: 'blob', // 关键：告知 axios 响应为 blob 流
          // 不需要重复设置 Authorization 和 Content-Type（request.js 已处理）
        });

        // 调用公共下载函数
        this.downloadFileFromBlob(response.data, fileName);
        ElMessage.success('数据导出成功！');
        console.log('--- 导出完成 ---');

      } catch (error) {
        console.error('--- 导出失败 ---', error);
        // 错误提示已在 request.js 中统一处理，此处可省略重复提示
      }
    },

    /**
     * 导出选中的申请数据
     */
    async ExportApplications() {
      if (this.selectedRows.length === 0) {
        ElMessage.warning('请先选择要导出的申请单');
        return;
      }

      // 过滤有效身份证号
      const idCardList = this.selectedRows
        .map(row => row.idCard)
        .filter(Boolean);

      if (idCardList.length === 0) {
        ElMessage.warning('选中的记录中无有效身份证号，无法导出');
        return;
      }

      // 生成文件名
      const fileName = `选中${this.selectedRows.length}条记录_申请数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
      await this.handleExport(idCardList, fileName);
    },

    /**
     * 导出全部申请数据
     */
    async exportAllApplications() {
      const fileName = `全部申请数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
      await this.handleExport([], fileName); // 空数组导出全部
    },

    async exportAllApplications() {
      try {
        this.$message.info('正在导出全部申请数据，请稍候...');

        console.log('--- 开始导出全部数据 ---');
        const requestBody = { idCardList: [] };
        console.log('最终发送的请求体:', requestBody);

        const response = await request({
          url: '/api/review/exportToExcel',
          method: 'post',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('userToken')}`,
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: requestBody,
          credentials: 'include',
          responseType: 'blob'
        });

        console.log('请求成功，开始处理文件流...');

        // 修复1：Blob 构造添加 charset=UTF-8（关键）
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });

        // 修复2：简化文件名，不依赖响应头
        const fileName = `全部申请数据_${new Date().toISOString().slice(0, 10)}.xlsx`;

        // 触发下载
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理资源
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$message.success('全部申请数据导出成功！');
        console.log('--- 导出完成 ---');

      } catch (error) {
        console.error('--- 导出全部数据失败 ---');
        console.error('错误对象:', error);
        // 修复3：错误处理中添加容错
        if (error.response) {
          console.error('响应状态码:', error.response.status);
          console.error('响应数据:', error.response.data);
          if (error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const errorMsg = JSON.parse(e.target.result);
                console.error('错误详情:', errorMsg);
                this.$message.error(`导出失败：${errorMsg.message || '服务器内部错误'}`);
              } catch (parseErr) {
                this.$message.error('导出失败，请检查控制台日志或联系管理员');
              }
            };
            reader.readAsText(error.response.data);
          } else {
            this.$message.error(`导出失败：${error.response.data?.message || '服务器内部错误'}`);
          }
        } else if (error.request) {
          console.error('请求没有收到响应，请检查网络连接');
          this.$message.error('导出失败：网络连接异常，请重试');
        } else {
          console.error('请求设置错误:', error.message);
          this.$message.error(`导出失败：${error.message}`);
        }
      }
    },

    // 表格行key获取（适配Element UI表格选择功能）
    getRowKey(row) {
      return row.id;
    },

    // 表格选择事件（选中行变化时触发）
    handleSelectionChange(val) {
      this.selectedRows = val;
      this.selectedRowKeys = val.map(row => row.id);
      console.log('选中的行数据:', this.selectedRows);
      console.log('选中的行ID:', this.selectedRowKeys);
    },
    // 退出登录方法（保持与问卷风格一致）
    handleLogout() {
      this.$confirm('确定要退出登录吗？未保存的数据可能会丢失', '退出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 1. 清除所有相关本地存储（覆盖用户相关数据）
        localStorage.removeItem('userToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('bingliCompleted');
        localStorage.removeItem('xinxiCompleted');
        localStorage.removeItem('zhengmingCompleted');
        localStorage.removeItem('uploadedFilePath');
        localStorage.removeItem('uploadedFileName');
        localStorage.removeItem('apiResponseData');
        localStorage.removeItem('missingFields'); // 清除可能的临时字段

        // 2. 清除 Vuex 角色状态（与你的问卷逻辑一致）
        this.$store.commit('clearUserRoles');

        // 3. 跳转到登录页（替换历史记录，避免回退）
        this.$router.push({
          path: '/denglu',
          replace: true // 关键：替换路由历史，防止用户回退到原页面
        }).then(() => {
          // 4. 退出成功提示（使用 Vant Toast，与上传功能提示一致）
          this.$toast.success('退出登录成功', {
            duration: 2000
          });
        });
      }).catch(() => {
        // 5. 取消退出提示
        this.$toast.info('已取消退出', {
          duration: 1500
        });
      });
    }
  }
};
</script>

<style scoped>
.audit-page {
  padding: 20px;
  background-color: #f9f9f9;
  min-height: calc(100vh - 60px);
}

.search-form {
  background-color: lightblue;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.application-list {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

/* 个人中心样式 */
.profile-content {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 120px);
}

.profile-card {
  width: 100%;
  max-width: 600px;
  padding: 30px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.profile-card h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-size: 18px;
}

.profile-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #ebeef5;
}

.profile-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.item-label {
  display: inline;
  width: 100px;
  font-weight: 500;
  color: #666;
  text-align: right;
  margin-right: 20px;
}

.item-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.signed-mark {
  margin-left: 15px;
  color: #67c23a;
}

.signed-mark i {
  margin-right: 5px;
}

/* 签字弹窗样式 */
.signature-dialog .el-dialog__body {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
}

.signature-pad-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
  padding: 20px;
}

.signature-pad {
  width: 100%;
  height: 100%;
  border: 2px dashed #ccc;
  background-color: #fff;
  cursor: crosshair;
}

.signature-actions {
  padding: 15px 20px;
  text-align: right;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

/* 移动端适配样式 */
@media (max-width: 768px) {
  .search-form {
    padding: 15px;
  }

  :deep(.responsive-form) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 12px;
  }

  :deep(.responsive-form .el-form-item) {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  :deep(.responsive-form .el-form-item__label) {
    width: 70px;
    flex-shrink: 0;
    text-align: right;
    padding-right: 10px;
  }

  :deep(.responsive-form .el-form-item__content) {
    flex: 1;
  }

  :deep(.responsive-form .el-input),
  :deep(.responsive-form .el-select),
  :deep(.responsive-form .el-date-picker) {
    width: 100% !important;
  }

  :deep(.responsive-form .action-buttons) {
    justify-content: center;
    padding-top: 10px;
  }

  .profile-card {
    padding: 20px 15px;
  }

  .profile-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .item-label {
    width: auto;
    text-align: left;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .logout-btn {
    background-color: #f5f5f5;
    color: #ff4d4f;
    border: 1px solid #ff4d4f;
  }

  .logout-btn:hover {
    background-color: #fff2f0;
  }
}
</style>